export function removeVendorPrefix(val: string): string {
  return val.replace(/^-(webkit|moz|ms|o)-/, "");
}

export default removeVendorPrefix;



// WEBPACK FOOTER //
// ./src/utils/removeVendorPrefix.ts